const APP_VERSION = "1.8.123";

export default APP_VERSION;
